var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5dbff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.926,
    x2: 188.561,
    xlinkHref: "#lg1",
    y1: 456.149,
    y2: 522.784
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90cc1c"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.389,
    x2: 58.25,
    xlinkHref: "#lg2",
    y1: 482.069,
    y2: 500.929
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.478,
    x2: 407.347,
    xlinkHref: "#lg1",
    y1: 409.667,
    y2: 497.536
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.023,
    x2: 475.884,
    xlinkHref: "#lg2",
    y1: 482.069,
    y2: 500.929
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.935,
    x2: 265.065,
    xlinkHref: "#lg1",
    y1: 457.949,
    y2: 457.949
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 0 0 -1 0 -1002.574)",
    gradientUnits: "userSpaceOnUse",
    x1: 121.926,
    x2: 188.561,
    xlinkHref: "#lg1",
    y1: -1056.425,
    y2: -989.79
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.389,
    x2: 58.25,
    xlinkHref: "#lg2",
    y1: 14.343,
    y2: 33.204
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 0 0 -1 0 -1002.574)",
    gradientUnits: "userSpaceOnUse",
    x1: 319.478,
    x2: 407.347,
    xlinkHref: "#lg1",
    y1: -1102.907,
    y2: -1015.038
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.023,
    x2: 475.884,
    xlinkHref: "#lg2",
    y1: 14.343,
    y2: 33.204
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(1 0 0 -1 0 -1002.574)",
    gradientUnits: "userSpaceOnUse",
    x1: 244.935,
    x2: 265.065,
    xlinkHref: "#lg1",
    y1: -1054.625,
    y2: -1054.625
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(0 1 -1 0 510 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1219.301,
    x2: 1259.327,
    xlinkHref: "#lg1",
    y1: 459.729,
    y2: 499.755
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 1 -1 0 510 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1161.308,
    x2: 1180.169,
    xlinkHref: "#lg2",
    y1: 481.233,
    y2: 500.094
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 -1 -1 0 510 278.518)",
    gradientUnits: "userSpaceOnUse",
    x1: -76.181,
    x2: -36.155,
    xlinkHref: "#lg1",
    y1: 459.729,
    y2: 499.755
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 -1 -1 0 510 278.518)",
    gradientUnits: "userSpaceOnUse",
    x1: -134.174,
    x2: -115.314,
    xlinkHref: "#lg2",
    y1: 481.233,
    y2: 500.094
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(0 1 -1 0 510 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.935,
    x2: 1329.065,
    xlinkHref: "#lg1",
    y1: 457.114,
    y2: 457.114
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(0 1 1 0 660.738 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1219.301,
    x2: 1259.327,
    xlinkHref: "#lg1",
    y1: -201.008,
    y2: -160.982
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(0 1 1 0 660.738 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1161.308,
    x2: 1180.169,
    xlinkHref: "#lg2",
    y1: -179.504,
    y2: -160.643
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(0 -1 1 0 660.738 278.518)",
    gradientUnits: "userSpaceOnUse",
    x1: -76.181,
    x2: -36.155,
    xlinkHref: "#lg1",
    y1: -201.008,
    y2: -160.982
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(0 -1 1 0 660.738 278.518)",
    gradientUnits: "userSpaceOnUse",
    x1: -134.174,
    x2: -115.314,
    xlinkHref: "#lg2",
    y1: -179.504,
    y2: -160.643
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(0 1 1 0 660.738 -1064)",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.935,
    x2: 1329.065,
    xlinkHref: "#lg1",
    y1: -203.624,
    y2: -203.624
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76e2f8"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.977,
    x2: 385.491,
    xlinkHref: "#lg3",
    y1: 174.805,
    y2: 465.319
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.929,
    x2: 368.649,
    xlinkHref: "#lg4",
    y1: 145.489,
    y2: 361.209
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.563,
    x2: 466.284,
    xlinkHref: "#lg4",
    y1: 47.854,
    y2: 263.575
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.838,
    x2: 481.352,
    xlinkHref: "#lg3",
    y1: 78.944,
    y2: 369.458
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.303,
    x2: 495.817,
    xlinkHref: "#lg3",
    y1: 64.479,
    y2: 354.993
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.324,
    x2: 385.045,
    xlinkHref: "#lg4",
    y1: 129.093,
    y2: 344.814
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.262,
    x2: 308.983,
    xlinkHref: "#lg4",
    y1: 205.155,
    y2: 420.876
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.123,
    x2: 404.843,
    xlinkHref: "#lg4",
    y1: 109.294,
    y2: 325.015
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.796,
    x2: 294.517,
    xlinkHref: "#lg4",
    y1: 219.621,
    y2: 435.342
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.775,
    x2: 405.289,
    xlinkHref: "#lg3",
    y1: 155.007,
    y2: 445.521
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.537,
    x2: 324.051,
    xlinkHref: "#lg3",
    y1: 236.245,
    y2: 526.759
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.171,
    x2: 421.685,
    xlinkHref: "#lg3",
    y1: 138.611,
    y2: 429.125
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.309,
    x2: 315.667,
    y1: 101.315,
    y2: 363.805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8fc5e9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56a4c8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2d8db1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147ea2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.108,
    x2: 65.459,
    xlinkHref: "#lg5",
    y1: 278.858,
    y2: 176.248
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.453,
    x2: 86.642,
    xlinkHref: "#lg5",
    y1: 368.629,
    y2: 236.588
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.959,
    x2: 157.57,
    xlinkHref: "#lg6",
    y1: 240.708,
    y2: 301.16
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.564,
    x2: 375.135,
    xlinkHref: "#lg5",
    y1: 320.987,
    y2: 243.558
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.179,
    x2: 415.064,
    xlinkHref: "#lg6",
    y1: 215.88,
    y2: 264.401
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.956 499.246h-106.234c-5.559 0-10.065-4.506-10.065-10.065s4.507-10.065 10.065-10.065h106.234c8.245 0 14.954-6.708 14.954-14.954v-48.198c0-5.559 4.507-10.065 10.065-10.065 5.559 0 10.065 4.506 10.065 10.065v48.198c0 19.345-15.739 35.084-35.084 35.084z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.183,
    cy: 488.863,
    fill: "url(#SVGID_2_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.044 499.246h106.234c5.559 0 10.065-4.506 10.065-10.065s-4.507-10.065-10.065-10.065h-106.234c-8.245 0-14.954-6.708-14.954-14.954v-48.198c0-5.559-4.507-10.065-10.065-10.065s-10.065 4.506-10.065 10.065v48.198c0 19.345 15.739 35.084 35.084 35.084z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.817,
    cy: 488.863,
    fill: "url(#SVGID_4_)",
    r: 21.137
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m255 510c-5.559 0-10.065-4.506-10.065-10.065v-83.971c0-5.559 4.506-10.065 10.065-10.065 5.559 0 10.065 4.506 10.065 10.065v83.971c0 5.559-4.506 10.065-10.065 10.065z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.956 10.754h-106.234c-5.559 0-10.065 4.506-10.065 10.065s4.507 10.065 10.065 10.065h106.234c8.245 0 14.954 6.708 14.954 14.954v48.198c0 5.559 4.507 10.065 10.065 10.065 5.559 0 10.065-4.506 10.065-10.065v-48.197c0-19.346-15.739-35.085-35.084-35.085z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.183,
    cy: 21.137,
    fill: "url(#SVGID_7_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.044 10.754h106.234c5.559 0 10.065 4.506 10.065 10.065s-4.507 10.065-10.065 10.065h-106.234c-8.245 0-14.954 6.708-14.954 14.954v48.198c0 5.559-4.507 10.065-10.065 10.065s-10.065-4.506-10.065-10.065v-48.197c0-19.346 15.739-35.085 35.084-35.085z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.817,
    cy: 21.137,
    fill: "url(#SVGID_9_)",
    r: 21.137
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m255 0c-5.559 0-10.065 4.506-10.065 10.065v83.971c0 5.559 4.506 10.065 10.065 10.065 5.559 0 10.065-4.506 10.065-10.065v-83.971c0-5.559-4.506-10.065-10.065-10.065z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.59 158.956v-48.315c0-5.559 4.506-10.065 10.065-10.065s10.065 4.507 10.065 10.065v48.315c0 8.245 6.708 14.954 14.954 14.954h48.198c5.559 0 10.065 4.507 10.065 10.065s-4.506 10.065-10.065 10.065h-48.198c-19.345 0-35.084-15.739-35.084-35.084z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.972,
    cy: 104.102,
    fill: "url(#SVGID_12_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.59 351.044v48.315c0 5.559 4.506 10.065 10.065 10.065s10.065-4.507 10.065-10.065v-48.315c0-8.245 6.708-14.954 14.954-14.954h48.198c5.559 0 10.065-4.507 10.065-10.065s-4.506-10.065-10.065-10.065h-48.198c-19.345 0-35.084 15.739-35.084 35.084z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.972,
    cy: 405.898,
    fill: "url(#SVGID_14_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.835 255c0-5.559 4.506-10.065 10.065-10.065h83.971c5.559 0 10.065 4.506 10.065 10.065 0 5.559-4.506 10.065-10.065 10.065h-83.97c-5.559 0-10.066-4.506-10.066-10.065z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m498.41 158.956v-48.315c0-5.559-4.506-10.065-10.065-10.065s-10.065 4.507-10.065 10.065v48.315c0 8.245-6.708 14.954-14.954 14.954h-48.198c-5.559 0-10.065 4.507-10.065 10.065s4.506 10.065 10.065 10.065h48.198c19.345 0 35.084-15.739 35.084-35.084z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.028,
    cy: 104.102,
    fill: "url(#SVGID_17_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m498.41 351.044v48.315c0 5.559-4.506 10.065-10.065 10.065s-10.065-4.507-10.065-10.065v-48.315c0-8.245-6.708-14.954-14.954-14.954h-48.198c-5.559 0-10.065-4.507-10.065-10.065s4.506-10.065 10.065-10.065h48.198c19.345 0 35.084 15.739 35.084 35.084z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.028,
    cy: 405.898,
    fill: "url(#SVGID_19_)",
    r: 21.137
  })), /*#__PURE__*/React.createElement("path", {
    d: "m509.165 255c0-5.559-4.506-10.065-10.065-10.065h-83.971c-5.559 0-10.065 4.506-10.065 10.065 0 5.559 4.506 10.065 10.065 10.065h83.971c5.558 0 10.065-4.506 10.065-10.065z",
    fill: "url(#SVGID_20_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m262.954 422.578 5.11-1.518c13.008-3.864 25.643-13.702 36.541-28.453 10.429-14.115 19.343-32.795 25.778-54.019l1.901-6.272-6.44 1.209c-18.717 3.511-38.577 5.586-59.025 6.166l-3.864.109v82.778z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.485 295.495-9.721 6.788c-7.504 5.239-16.306 10.081-26.163 14.389-9.295 4.063-19.572 7.686-30.546 10.769l-2.227.625-.558 2.244c-4.876 19.622-11.593 37.418-19.964 52.892-3.959 7.318-8.3 14.1-12.902 20.157l-9.133 12.023 13.871-5.963c44.578-19.166 78.724-56.578 93.681-102.647z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.271 179.69.558 2.244 2.227.625c10.974 3.082 21.251 6.706 30.546 10.769 9.857 4.308 18.659 9.15 26.163 14.389l9.721 6.788-3.661-11.277c-14.958-46.069-49.103-83.481-93.681-102.647l-13.871-5.963 9.133 12.023c4.602 6.057 8.942 12.839 12.902 20.157 8.37 15.475 15.087 33.269 19.963 52.892z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.704 201.57-6.189-2.093.983 6.458c2.42 15.903 3.648 32.41 3.648 49.065s-1.227 33.162-3.648 49.065l-.983 6.458 6.189-2.093c39.633-13.402 63.294-33.376 63.294-53.43s-23.661-40.028-63.294-53.43z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.064 88.94-5.11-1.518v82.777l3.864.11c20.449.58 40.308 2.655 59.025 6.166l6.44 1.209-1.901-6.272c-6.435-21.224-15.349-39.904-25.778-54.019-10.897-14.751-23.532-24.59-36.54-28.453z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.954 323.894 4.095-.121c23.571-.699 46.022-3.428 66.731-8.11l2.532-.572.495-2.549c3.603-18.56 5.43-37.92 5.43-57.542s-1.827-38.981-5.43-57.542l-.495-2.549-2.532-.572c-20.709-4.682-43.16-7.411-66.731-8.11l-4.095-.121z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.296 308.43 6.189 2.093-.983-6.458c-2.42-15.903-3.648-32.411-3.648-49.065s1.227-33.162 3.648-49.065l.983-6.458-6.189 2.093c-39.633 13.402-63.294 33.376-63.294 53.43s23.661 40.028 63.294 53.43z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.046 87.422-5.11 1.518c-13.008 3.864-25.643 13.702-36.541 28.453-10.429 14.115-19.343 32.795-25.778 54.019l-1.901 6.272 6.44-1.209c18.717-3.511 38.577-5.586 59.025-6.166l3.864-.11v-82.777z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.936 421.06 5.11 1.518v-82.777l-3.864-.109c-20.449-.58-40.308-2.655-59.025-6.166l-6.44-1.209 1.901 6.272c6.435 21.224 15.349 39.904 25.778 54.019 10.897 14.75 23.532 24.589 36.54 28.452z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.046 186.106-4.095.121c-23.571.699-46.022 3.428-66.731 8.11l-2.532.572-.495 2.549c-3.603 18.56-5.43 37.92-5.43 57.542s1.827 38.981 5.43 57.542l.495 2.549 2.532.572c20.709 4.682 43.16 7.411 66.731 8.11l4.095.121z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.857 409.419 13.871 5.963-9.133-12.023c-4.601-6.057-8.942-12.839-12.902-20.157-8.371-15.474-15.088-33.27-19.964-52.892l-.558-2.244-2.227-.625c-10.974-3.082-21.251-6.706-30.546-10.769-9.857-4.308-18.658-9.15-26.163-14.389l-9.721-6.788 3.661 11.277c14.958 46.068 49.104 83.481 93.682 102.647z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.398 193.328c9.295-4.063 19.572-7.686 30.546-10.769l2.227-.625.558-2.244c4.876-19.623 11.593-37.418 19.964-52.892 3.96-7.318 8.301-14.1 12.902-20.157l9.133-12.023-13.871 5.963c-44.578 19.166-78.724 56.578-93.681 102.647l-3.661 11.277 9.721-6.788c7.503-5.239 16.305-10.081 26.162-14.389z",
    fill: "url(#SVGID_32_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m387.854 122.146c-35.487-35.486-82.668-55.029-132.854-55.029s-97.367 19.543-132.854 55.03-55.029 82.667-55.029 132.853 19.543 97.367 55.03 132.854 82.668 55.03 132.854 55.03 97.367-19.543 132.854-55.03 55.03-82.668 55.03-132.854-19.545-97.367-55.031-132.854zm-216.114 132.854c0-19.844 1.904-38.996 5.357-56.783 19.506-4.411 41.714-7.295 65.972-8.014v129.595c-24.258-.719-46.466-3.604-65.972-8.014-3.453-17.788-5.357-36.94-5.357-56.784zm-20.17 49.663c-37.914-12.821-60.591-31.832-60.591-49.663s22.677-36.842 60.591-49.663c-2.433 15.986-3.693 32.658-3.693 49.663s1.26 33.677 3.693 49.663zm175.007-132.097c-18.795-3.526-38.901-5.644-59.646-6.232v-73.582c25.099 7.456 46.954 37.949 59.646 79.814zm-83.508-79.814v73.581c-20.745.588-40.851 2.707-59.646 6.232 12.692-41.864 34.547-72.357 59.646-79.813zm0 250.915v73.581c-25.099-7.456-46.953-37.949-59.646-79.813 18.795 3.525 38.901 5.644 59.646 6.232zm23.862 73.581v-73.581c20.745-.588 40.851-2.707 59.646-6.232-12.692 41.864-34.547 72.357-59.646 79.813zm0-97.451v-129.594c24.258.719 46.466 3.604 65.972 8.014 3.453 17.787 5.357 36.94 5.357 56.783s-1.904 38.996-5.357 56.783c-19.506 4.411-41.714 7.296-65.972 8.014zm91.499-114.46c37.914 12.821 60.591 31.832 60.591 49.663s-22.677 36.842-60.591 49.663c2.433-15.986 3.693-32.658 3.693-49.663s-1.26-33.677-3.693-49.663zm52.611-.88c-7.663-5.352-16.629-10.306-26.846-14.772-9.564-4.18-19.98-7.84-31.064-10.953-4.903-19.732-11.734-37.943-20.326-53.825-4.113-7.602-8.541-14.495-13.232-20.671 43.172 18.561 76.831 55.141 91.468 100.221zm-220.613-100.222c-4.691 6.176-9.12 13.069-13.232 20.671-8.592 15.881-15.423 34.093-20.326 53.825-11.084 3.113-21.5 6.773-31.064 10.953-10.217 4.466-19.183 9.421-26.846 14.772 14.636-45.079 48.295-81.659 91.468-100.221zm-91.469 201.308c7.663 5.352 16.629 10.306 26.846 14.772 9.564 4.18 19.98 7.84 31.064 10.953 4.903 19.732 11.734 37.943 20.326 53.825 4.113 7.602 8.541 14.495 13.232 20.671-43.172-18.561-76.831-55.141-91.468-100.221zm220.613 100.222c4.691-6.176 9.12-13.069 13.232-20.671 8.592-15.881 15.423-34.093 20.326-53.825 11.084-3.113 21.5-6.773 31.064-10.953 10.217-4.466 19.183-9.421 26.846-14.772-14.636 45.079-48.295 81.659-91.468 100.221z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.854 387.854c35.487-35.486 55.03-82.668 55.03-132.854s-19.543-97.367-55.03-132.854-82.668-55.029-132.854-55.029v375.767c50.186-.001 97.367-19.544 132.854-55.03z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.707 386.98-188.059-188.059c-2.027-3.687-5.946-3.922-10.71-3.854l-72.194 1.836c-9.448.136-11.869 7.436-6.733 15.368l7.907 12.213c-20.797 16.622-40.109 39.027-48.756 64.428 6.758 37.275 24.627 71.585 51.983 98.942 35.486 35.487 82.668 55.03 132.854 55.03s97.367-19.543 132.854-55.03c.289-.289.568-.584.854-.874z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.166 383.622c-3.044-9.477-7.6-44.77-7.256-55.321.832-25.519 12.512-48.37 30.516-64.138l8.101 12.512c5.136 7.932 16.994 7.109 20.985-1.456l30.495-65.445c3.745-8.037-2.203-17.223-11.068-17.095l-72.194 1.04c-9.448.136-15.052 10.619-9.917 18.551l7.907 12.213c-30.836 24.647-51.435 61.995-52.547 102.996-.118 4.33.599 11.026 1.71 18.502 3.781 25.451 28.021 42.614 53.268 37.641z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.928 126.361c-.031.006-.062.011-.093.017 3.044 9.477 7.6 44.77 7.256 55.321-.793 24.314-11.438 46.202-28.013 61.853l-11.107-10.949c-5.369-7.151-16.616-6.119-20.481 2.178l-30.495 65.445c-2.552 5.476-.601 11.483 3.704 14.717l74.02 74.02c.377-.371.761-.734 1.135-1.108 35.487-35.486 55.03-82.668 55.03-132.854-.001-48.227-18.057-93.674-50.956-128.64z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.834 126.378c3.044 9.477 7.6 44.77 7.256 55.321-.832 25.519-12.512 48.37-30.516 64.138l-8.101-12.512c-5.136-7.932-16.994-7.109-20.985 1.456l-30.495 65.445c-3.745 8.037 2.203 17.223 11.068 17.095l72.194-1.04c9.448-.136 15.052-10.619 9.917-18.551l-7.907-12.213c30.837-24.646 51.435-61.994 52.548-102.995.117-4.33-.599-11.026-1.71-18.502-3.782-25.452-28.022-42.615-53.269-37.642z",
    fill: "url(#SVGID_38_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiConnectionIcon);
export default __webpack_public_path__ + "static/media/api-connection-icon.c216a19a321bd74d59cbbfca1cd96aec.svg";
export { ForwardRef as ReactComponent };